const apiInterface = {
  /**********************************************************************/
  /* 账户接口                                                           */
  /**********************************************************************/
  // 发送短信验证码
  sendSmsVerificationCode: {
    url: '/api/sendSmsVerificationCode',
    method: 'post'
  },
  // 登录
  login: {
    url: '/api/login',
    method: 'post'
  },
  // 注销登录
  logout: {
    url: '/api/logout',
    method: 'post'
  },
  // 单点登录
  ssoLogin: {
    url: '/api/ssoLogin',
    method: 'post'
  },
  /**********************************************************************/
  /* 控制接口                                                           */
  /**********************************************************************/
  // 调阅实时视频
  startVideo: {
    url: '/api/streamnode/startVideo',
    method: 'post'
  },
  // 停止调阅实时视频
  stopVideo: {
    url: '/api/streamnode/stopVideo',
    method: 'post'
  },
  // 云控控制
  ptzControl: {
    url: '/api/streamnode/ptzControl',
    method: 'post'
  },
  // 预置点控制
  presetControl: {
    url: '/api/streamnode/presetControl',
    method: 'post'
  },
  // 抓图
  capturePicture: {
    url: '/api/streamnode/capturePicture',
    method: 'post'
  },
  // 报警布撤防
  alarmDeploy: {
    url: '/api/datanode/deploy',
    method: 'post'
  },
  // 消警
  cancelAlarm: {
    url: '/api/datanode/cancelAlarm',
    method: 'post'
  },
  // DO控制
  doControl: {
    url: '/api/controlnode/doControl',
    method: 'post'
  },
  // AO控制
  aoControl: {
    url: '/api/controlnode/aoControl',
    method: 'post'
  },
  // Voip控制
  voipControl: {
    url: '/api/voicenode/voipControl',
    method: 'post'
  },
  /**********************************************************************/
  /* 消息接口                                                           */
  /**********************************************************************/
  // 实时事件查询
  realEventList: {
    url: '/api/message/eventList',
    method: 'post'
  },
  // 实时数据查询
  realDataList: {
    url: '/api/message/dataList',
    method: 'post'
  },
  /**********************************************************************/
  /* 资源接口                                                           */
  /**********************************************************************/
  // 区域列表
  regionList: {
    url: '/api/region/list',
    method: 'post'
  },
  // 监控设备列表
  encoderList: {
    url: '/api/encoder/list',
    method: 'post'
  },
  // 辅助监控设备列表
  auxMonitoringDeviceList: {
    url: '/api/auxmonitoringdevice/list',
    method: 'post'
  },
  // 添加辅助监控设备
  addAuxMonitoringDevice: {
    url: '/api/auxmonitoringdevice/add',
    method: 'post'
  },
  // 修改辅助监控设备
  updateAuxMonitoringDevice: {
    url: '/api/auxmonitoringdevice/update',
    method: 'post'
  },
  // 修改辅助监控设备
  deleteAuxMonitoringDevice: {
    url: '/api/auxmonitoringdevice/delete',
    method: 'post'
  },
  // 从视频节点同步监控设备
  synchAuxMonitoringDeviceFromStreamNode: {
    url: '/api/auxmonitoringdevice/synchFromStreamNode',
    method: 'post'
  },
  // 视频节点列表
  streamNodeList: {
    url: '/api/streamnode/list',
    method: 'post'
  },
  // 视频节点状态列表
  streamNodeStateList: {
    url: '/api/streamnode/stateList',
    method: 'post'
  },
  // 修改视频节点
  updateStreamNode: {
    url: '/api/streamnode/update',
    method: 'post'
  },
  // 视频节点关联控制节点列
  controlNodeListForStreamNode: {
    url: '/api/streamnode/controlNodeList',
    method: 'post'
  },
  // 语音节点列表
  voiceNodeList: {
    url: '/api/voicenode/list',
    method: 'post'
  },
  // 语音节点状态列表
  voiceNodeStateList: {
    url: '/api/voicenode/stateList',
    method: 'post'
  },
  // 修改语音节点
  updateVoiceNode: {
    url: '/api/voicenode/update',
    method: 'post'
  },
  // 数据节点列表
  dataNodeList: {
    url: '/api/datanode/list',
    method: 'post'
  },
  // 数据节点状态列表
  dataNodeStateList: {
    url: '/api/datanode/stateList',
    method: 'post'
  },
  // 新增数据节点
  addDataNode: {
    url: '/api/datanode/add',
    method: 'post'
  },
  // 更新数据节点
  updateDataNode: {
    url: '/api/datanode/update',
    method: 'post'
  },
  // 数据节点关联视频节点列
  streamNodeListForDataNode: {
    url: '/api/datanode/streamNodeList',
    method: 'post'
  },
  // 数据节点关联控制节点列
  controlNodeListForDataNode: {
    url: '/api/datanode/controlNodeList',
    method: 'post'
  },
  // 控制节点列表
  controlNodeList: {
    url: '/api/controlnode/list',
    method: 'post'
  },
  // 数据节点状态列表
  controlNodeStateList: {
    url: '/api/controlnode/stateList',
    method: 'post'
  },
  // 预置点列表
  presetInfoList: {
    url: '/api/presetinfo/list',
    method: 'post'
  },
  // 场景列表
  sceneList: {
    url: '/api/scene/list',
    method: 'post'
  },
  // 根据场景返回视频节点列表
  sceneStreamNodeList: {
    url: '/api/scene/streamNodeList',
    method: 'post'
  },
  // 根据用户收藏返回视频节点列表
  userCollectionStreamNodeList: {
    url: '/api/userCollection/streamNodeList',
    method: 'post'
  },
  // GIS标记列表
  gisMarkerList: {
    url: '/api/gisMarker/List',
    method: 'post'
  },
  // 服务器列表
  serverList: {
    url: '/api/server/list',
    method: 'post'
  },
  // 服务列表
  serviceList: {
    url: '/api/service/list',
    method: 'post'
  },
  // 录像空间列表
  recordSpaceList: {
    url: '/api/recordspace/list',
    method: 'post'
  },
  // 新增录像空间
  addRecordSpace: {
    url: '/api/recordspace/add',
    method: 'post'
  },
  // 修改录像空间
  updateRecordSpace: {
    url: '/api/recordspace/update',
    method: 'post'
  },
  // 删除录像空间
  deleteRecordSpace: {
    url: '/api/recordspace/delete',
    method: 'post'
  },
  // 录像任务列表
  recordTaskList: {
    url: '/api/recordtask/list',
    method: 'post'
  },
  // 录像任务关联录像空间列表
  recordSpaceListForRecordTask: {
    url: '/api/recordtask/recordSpaceList',
    method: 'post'
  },
  // 录像任务关联视频节点列表
  streamNodeListForRecordTask: {
    url: '/api/recordtask/streamNodeList',
    method: 'post'
  },
  // 新增录像任务
  addRecordTask: {
    url: '/api/recordtask/add',
    method: 'post'
  },
  // 添加录像任务关联录像空间
  addRecordSpaceForRecordTask: {
    url: '/api/recordtask/addRecordSpace',
    method: 'post'
  },
  // 删除录像任务关联录像空间
  deleteRecordSpaceForRecordTask: {
    url: '/api/recordtask/deleteRecordSpace',
    method: 'post'
  },
  // 添加录像任务关联视频节点
  addStreamNodeForRecordTask: {
    url: '/api/recordtask/addStreamNode',
    method: 'post'
  },
  // 删除录像任务关联视频节点
  deleteStreamNodeForRecordTask: {
    url: '/api/recordtask/deleteStreamNode',
    method: 'post'
  },
  // 修改录像任务
  updateRecordTask: {
    url: 'api/recordtask/update',
    method: 'post'
  },
  // 删除录像任务
  deleteRecordTask: {
    url: '/api/recordtask/delete',
    method: 'post'
  },
  // 录像记录列表
  recordRecordList: {
    url: '/api/recordrecord/list',
    method: 'post'
  },
  // 锁定录像记录
  lockRecordRecord: {
    url: '/api/recordrecord/lock',
    method: 'post'
  },
  // 抓拍任务列表
  captureTaskList: {
    url: '/api/capturetask/list',
    method: 'post'
  },
  // 抓拍任务关联视频节点列表
  streamNodeListForCaptureTask: {
    url: '/api/capturetask/streamNodeList',
    method: 'post'
  },
  // 新增抓拍任务
  addCaptureTask: {
    url: '/api/capturetask/add',
    method: 'post'
  },
  // 添加抓拍任务关联视频节点
  addStreamNodeForCaptureTask: {
    url: '/api/capturetask/addStreamNode',
    method: 'post'
  },
  // 删除抓拍任务关联视频节点
  deleteStreamNodeForCaptureTask: {
    url: '/api/capturetask/deleteStreamNode',
    method: 'post'
  },
  // 修改抓拍任务
  updateCaptureTask: {
    url: 'api/capturetask/update',
    method: 'post'
  },
  // 删除抓拍任务
  deleteCaptureTask: {
    url: '/api/capturetask/delete',
    method: 'post'
  },
  // 抓拍记录列表
  captureRecordList: {
    url: '/api/capturerecord/list',
    method: 'post'
  },
  // 锁定抓拍记录
  lockCaptureRecord: {
    url: '/api/capturerecord/lock',
    method: 'post'
  },
  // 部门列表
  departmentList: {
    url: '/api/department/list',
    method: 'post'
  },
  // 人员列表
  personList: {
    url: '/api/person/list',
    method: 'post'
  },
  // 项目列表
  projectList: {
    url: '/api/project/list',
    method: 'post'
  },
  // 地图列表
  mapList: {
    url: '/api/map/list',
    method: 'post'
  },
  // 地图节点列表
  mapNodeList: {
    url: '/api/mapnode/list',
    method: 'post'
  },
  // 地图节点模型列表
  mapNodeModelList: {
    url: '/api/mapnodemodel/list',
    method: 'post'
  },
  // 地图动作列表
  mapActionList: {
    url: '/api/mapaction/list',
    method: 'post'
  },
  // 用户列表
  userList: {
    url: '/api/user/list',
    method: 'post'
  },
  /**********************************************************************/
  /* 状态接口                                                           */
  /**********************************************************************/
  // 视频诊断状态列表
  streamNodeDiagnosisList: {
    url: '/api/streamnode/diagnosisList',
    method: 'post'
  },
  /**********************************************************************/
  /* 历史记录接口                                                           */
  /**********************************************************************/
  // 历史事件查询
  historyEventList: {
    url: '/api/log/historyEventList',
    method: 'post'
  },
  // 历史事件导出
  historyEventExportXls: {
    url: '/api/log/historyEventExportXls',
    method: 'post'
  },
  // 历史车辆违章检测事件导出
  historyVehicleViolationEventExportXls: {
    url: '/api/log/historyVehicleViolationEventExportXls',
    method: 'post'
  },
  // 确认告警
  confirmAlarm: {
    url: '/api/log/confirmAlarm',
    method: 'post'
  },
  // 历史数据查询
  historyDataList: {
    url: '/api/log/historyDataList',
    method: 'post'
  },
  // 历史日志查询
  historyLogList: {
    url: '/api/log/historyLogList',
    method: 'post'
  },
  /**********************************************************************/
  /* 统计接口                                                           */
  /**********************************************************************/
  // 系统种类资源数量
  systemKindResourceCountList: {
    url: '/api/stat/systemKindResourceCountList',
    method: 'post'
  },
  // 最值统计
  theMostValueStatList: {
    url: '/api/stat/theMostValueStatList',
    method: 'post'
  },
  // 区域告警次数统计
  regionAlarmTimesStatList: {
    url: '/api/stat/regionAlarmTimesStatList',
    method: 'post'
  },
  // 区域离线次数统计
  regionOfflineTimesStatList: {
    url: '/api/stat/regionOfflineTimesStatList',
    method: 'post'
  },
  // 区域事件数量统计
  regionEventCountStatList: {
    url: '/api/stat/regionEventCountStatList',
    method: 'post'
  },
  // 根据区域进行摄像机建档数统计
  cameraArchiveStatByRegionList: {
    url: '/api/stat/cameraArchiveStatByRegionList',
    method: 'post'
  },
  // 根据行业进行摄像机建档数统计
  cameraArchiveStatByIndustryList: {
    url: '/api/stat/cameraArchiveStatByIndustryList',
    method: 'post'
  },
  // 根据区域进行视频诊断统计
  videoDiagnosisStatByRegionList: {
    url: '/api/stat/videoDiagnosisStatByRegionList',
    method: 'post'
  },
  // 根据行业进行视频诊断统计
  videoDiagnosisStatByIndustryList: {
    url: '/api/stat/videoDiagnosisStatByIndustryList',
    method: 'post'
  },
  /**********************************************************************/
  /* 系统接口                                                           */
  /**********************************************************************/
  // 系统菜单列表
  systemMenuList: {
    url: '/api/systemmenu/list',
    method: 'post'
  },
  // 系统设定列表
  systemSettingList: {
    url: '/api/systemsetting/list',
    method: 'post'
  }
}

export default apiInterface



// WEBPACK FOOTER //
// ./src/api/interface.js